<template>
    <v-chip
        x-small
        label
        outlined
        :color="option.color"
        :alvqa="alvqa + '-chip-outcome-' + outcome"
    ><span class="text--primary">{{ $t(option.text) }}</span></v-chip>
</template>

<script>
import { OUTCOMES } from '../usageOptions'

export default {
    name: 'OutcomeChip',
    props: {
        outcome: { type: String, required: true },
        alvqa: { type: String, default: '' }
    },
    computed: {
        option() { return OUTCOMES.find(o => o.value === this.outcome) || { text: this.outcome, color: 'iconDelete' } }
    }
}
</script>
